import type { FeatureGroup } from '../../../types';
import { CRM_FEATURE_GROUP } from '../group';

export const CRM_DONATIONS_FEATURE_GROUP: FeatureGroup = {
  guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a04ff',
  name: 'crm_donations',
  description: 'The CRM donations page',
  product: 'crm',
  parentGuid: CRM_FEATURE_GROUP.guid,
};
